module.exports = __webpack_public_path__ + "img/Philippines-hover.c2a713ef.jpg";